import { render, staticRenderFns } from "./AutoInputForm.vue?vue&type=template&id=cdf5fc7a&scoped=true&"
import script from "./AutoInputForm.vue?vue&type=script&lang=js&"
export * from "./AutoInputForm.vue?vue&type=script&lang=js&"
import style0 from "./AutoInputForm.vue?vue&type=style&index=0&id=cdf5fc7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf5fc7a",
  null
  
)

export default component.exports